/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface UpdatePhoneLabel$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  id: number;
  label: string;
}

export function updatePhoneLabel(http: HttpClient, rootUrl: string, params: UpdatePhoneLabel$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updatePhoneLabel.PATH, 'patch');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('id', params.id, {});
    rb.query('label', params.label, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updatePhoneLabel.PATH = '/v1/api/ui/company/number/{id}/label';
